module.exports = __webpack_public_path__ + "static/media/mediaAssetPools.ce4aed86.svg";